import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ArticleForm from '../../../components/forms/ArticleForm';
import { useArticleApi } from '../../../hooks/useArticleApi';
import { useNavigate, useParams } from 'react-router-dom';
import { ArticleDTO } from '../../../services/apiClient';

const ArticleEdit: React.FC = () => {
  const { getById, edit } = useArticleApi();
  const [entityData, setEntityData] = useState<ArticleDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Articles', href: '/admin/articles' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching Article data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      navigate('/admin/articles');
    } catch (error) {
      console.error('Error updating Article:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/articles"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Content.Article.Edit'
    >
      {entityData ? (
        <ArticleForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/articles')}
          isLoading={isSubmitting}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default ArticleEdit;